import Vue from 'vue';
import router from './routes/router.js';
import App from './App.vue';

new Vue({
  router: router,
  // mode: 'history',
  render: (h) => h(App),
}).$mount('#app');
